import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/mir.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/mobile.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/sber.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/sbp.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/tinkoff.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/vk.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/dzen.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/odnoklassniki.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/ula.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/vk-cloud.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/vk-mail.svg");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollTarget"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/analytics/components/ScrollTarget.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/assets/career/float_1.webp");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/assets/career/float_2.webp");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/assets/career/float_3.webp");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/assets/career/float_4.webp");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/assets/career/float_5.webp");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/assets/career/float_6.webp");
;
import(/* webpackMode: "eager", webpackExports: ["Parallaxer"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/components/Parallaxer/Parallaxer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/components/StrapiHeader/Header.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/layouts/PageLayout.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/layouts/PageViewLogger.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Career/Awards/Award.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Career/Awards/Awards.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Career/Career.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedBanner"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Career/Intro/AnimatedBanner.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Career/Intro/Intro.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["IntroHeightMeasurer"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Career/IntroHeightMeasurer.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Career/Outro/Outro.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Career/Principles/Principle.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Career/Principles/Principles.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Career/Product/Advantage.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Career/Product/Product.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Career/Startup/Feature.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Career/Startup/Startup.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Career/Stats/Stat.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Career/Stats/Stats.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Career/VacanciesSiteLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Video"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Career/Video/Video.tsx");
